import { MENU_OPTION, GROUP_MENU_OPENED } from "./types";

export const menuOptionsAction = (name) => (dispatch) => {
    dispatch({ type: MENU_OPTION, payload: name });
};

export const menuGroupOpenedAction = (name) => (dispatch) => {
    dispatch({ type: GROUP_MENU_OPENED, payload: name})
}